import { type Translationtype } from "utils";
import { Tooltip } from "../components/tooltip";
import type { autoCompleteType } from "./formTypes";

interface IFormInputProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  autoComplete?: autoCompleteType;
  type?: string;
  step?: string;
  name: string;
  title: string;
  tooltip?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  t: Translationtype;
  isRequired?: boolean;
  maxLength?: number;
}

export function FormInput({
  register,
  errors,
  className,
  disabled,
  placeholder,
  autoComplete,
  type,
  step,
  name,
  title,
  tooltip,
  onFocus,
  onBlur,
  isRequired = false,
  maxLength,
  t,
}: IFormInputProps) {
  return (
    <div className={`${className || ""} w-full`}>
      <label htmlFor={name} className="w-full block mb-1 text-textColor">
        {title}
        {isRequired ? <span className="text-red-500"> *</span> : null}
        {tooltip ? <Tooltip text={tooltip} /> : null}
      </label>
      <input
        id={name}
        onFocus={onFocus?.()}
        disabled={disabled || false}
        type={type || "text"}
        step={step}
        autoComplete={autoComplete}
        aria-autocomplete={autoComplete}
        className={`input ${disabled ? "!bg-gray-200" : ""} w-full`}
        placeholder={placeholder || ""}
        maxLength={maxLength}
        {...register(name)}
        onBlur={() => {
          onBlur?.();
        }}
      />
      {!disabled && errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
